export default function stepsList(state = [], action) {
  if (action.type === 'stepsList') {
    return action.stepsList;
  }
  return state;
}